/**
 * Created by guga on 8/4/2016.
 */

import { RequestOptions } from '@angular/http';

export enum RequestMethod {
    get,
    post,
    postJson,
    put,
    putJson,
    delete
}

export interface IRequestPayload {
    url     : string;
    body   ?: string | any;
    options : RequestOptions;
    method  : RequestMethod;
}

export function createRequestPayload(url : string, method : RequestMethod, body : any, options : RequestOptions) {
    return {url, method, body, options};
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas-models/request-payload.ts